module.exports = __webpack_public_path__ + "static/media/outdoor_lounge_rendering.de19eff4.jpg";